export default "/images/stuhmer-logo.svg?30656c5a1cf262b16d621d6045410f65";